import styled from 'styled-components';

const LARGE_MOBILE = `34.375rem`;

export const SignUpFormWrapper = styled.div`
  background-color: #ffffff;
  border: solid 3px #E5ECED;
  padding: 1.5rem 2rem;
  margin: 1rem auto;
  display: block;
  border-radius: 1rem;
  box-shadow: rgba(0,0,0,.1) 2px 3px 7px;
  max-width: 37.5rem;

  @media only screen and (max-width: ${LARGE_MOBILE}) {
    border-right: none;
    border-left: none;
    margin: 0 auto;
    display: block;
    border-radius: 0;
  }
`;

export const SignUpFormTitle = styled.h3`
  text-align: center;
  font-size: 1.25rem;
  max-width: 41.25rem;
  margin: .5rem auto 1rem auto;
  font-family: Calistoga;
`;
